exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-height: 601px){\n  .justify{\n    text-align: justify;\n  }\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/yoann/Perso/Pedicure-Podologue/src/app/podologie-sport/podologie-sport.component.css
// module id = ../../../../../src/app/podologie-sport/podologie-sport.component.css
// module chunks = 1